import { observable, action, } from 'mobx';
import { Injectable } from '@angular/core';
import { DataService } from 'src/app/services/data.service';
import { pushToArray } from 'src/app/services/mapping.service';
import { STUDENT_FILER_OPTIONS, READING_MEMBER_OBJECT, STATUS_OBJECT, DISPLAY_STATUS_OBJECT } from 'src/app/dummy/status';
import { ITrainingStudent, ITrainingTutor, ITrainingBatch, ITrainingAdmission, ITrainingBatchStudent } from 'src/app/interfaces/training';
import * as firebase from 'firebase/app';
import { IReadingMember, ISchool } from 'src/app/interfaces/student';
import { APP_OBJECTS, COLLECTION_NAME } from 'src/app/dummy/app';

@Injectable()
export class TrainingStore {
  @observable data: any[] = [];
  @observable process: boolean = false;
  @observable loading: boolean = true;
  @observable empty: boolean = false;

  @observable filterType: any = STUDENT_FILER_OPTIONS[0];
  constructor(private ds: DataService) { }


  @action
  addStudentBatch(item: ITrainingBatchStudent, batchData: any, callback) {
    this.process = true;
    const batch = this.ds.batch();
    const studentRef = this.ds.firestore().collection(COLLECTION_NAME.STUDENTS).doc(item.student.key);
    const batchRef = this.ds.firestore().collection(COLLECTION_NAME.READING_BATCHES).doc(item.batchKey).collection("students").doc(item.key);
    batch.set(batchRef, item);
    batch.update(studentRef, {
      batchData: batchData,
      batchKey: batchData.key,
      batchRef: this.ds.readingBatchRef().doc(batchData.key).ref,
    })
    batch.commit().then(() => {
      callback(true, null);
    }).catch((error) => {
      alert(error);
      callback(false, error)
    }).finally(() => {
      this.process = false;
    })
  }

  @action
  async fetchReadingStudent() {
    const doc = await this.ds.userMemberSearchListRef(READING_MEMBER_OBJECT.students.key, this.filterType.key).get().toPromise();
    this.data = pushToArray(doc);
    this.loading = false;
  }
  @action
  fetchFilterReadingStudent(field, searchText) {
    return this.ds.userMemberSearchListRef(READING_MEMBER_OBJECT.students.key, this.filterType.key, field, searchText).valueChanges();
  }

  @action
  async fetchStudent() {
    const doc = await this.ds.trainingStudentRef(this.filterType.key).get().toPromise();
    this.data = pushToArray(doc);
    this.loading = false;
  }

  @action
  fetchFilterStudent(field, searchText) {
    return this.ds.trainingStudentFilterRef(field, searchText).valueChanges();
  }

  @action
  async saveMember(item: IReadingMember, level, isNew, callback) {
    this.process = true;
    const batch = this.ds.batch();
    const studentRef = this.ds.studentFireRef().doc(item.key);
    if (item.appName && item.appName.key === APP_OBJECTS[1].key) {
      const lessonDoc = await this.ds.programRef().doc(item.program.key)
        .collection('levels').doc(item.level.key)
        .collection('lessons', ref => ref.orderBy('updated_at').limit(1)).get().toPromise();
      if (lessonDoc.empty) {
        alert("Sorry you cannot register student with current lesson level empty. Please at lesson to level before add student to this level.")
        return;
      }
      const firstLesson = pushToArray(lessonDoc)[0];
      const admissionRef = this.ds.admissionFireRef();
      const admissionKey = isNew ? this.ds.createId() : item.currentAdmissionKey;
      const enrollmentKey = isNew ? this.ds.createId() : item.currentEnrollmentKey;
      const enrollment = {
        ...level,
        program: item.program,
        package: item.package,
        packageRef: item.packageRef || null,
        totalMonth: item.totalMonth,
        memberCreatedDate: item.memberCreatedDate,
        enrollmentKey: enrollmentKey,
        admissionKey: admissionKey,
        enrollmentDate: this.ds.serverTimestamp(),
        enrollmentBy: item.created_by,
        organizationKey: item.organizationKey,
        organizationRef: item.organizationRef,
        registerProgramKey: item.program.key,
        studentKey: item.key,
        studentRef: this.ds.studentRef().doc(item.key).ref,
        programKey: item.program.key,
        programRef: this.ds.programRef().doc(item.program.key).ref,
        levelKey: item.level.key,
        levelRef: this.ds.programRef().doc(item.program.key).collection('levels').doc(item.level.key).ref,
        currentLessonKey: firstLesson.key,
        currentLessonRef: this.ds.programRef().doc(item.program.key).collection('levels').doc(item.level.key).collection('lessons').doc(firstLesson.key).ref,
      }
      if (isNew) {//new student
        const movement = {
          admissionStatus: DISPLAY_STATUS_OBJECT.ACTIVE,
          key: admissionKey,
          organizationKey: item.organizationKey,
          organizationRef: item.organizationRef,
          registerProgramKey: item.program.key,
          studentKey: item.key,
          studentRef: this.ds.studentRef().doc(item.key).ref,
          startLevelKey: item.level.key,
          startLevelRef: this.ds.programRef().doc(item.program.key).collection('levels').doc(item.level.key).ref,
          programKey: item.program.key,
          programRef: this.ds.programRef().doc(item.program.key).ref,
        }

        item.currentAdmissionKey = admissionKey;
        item.currentAdmissionRef = admissionRef.doc(admissionKey);
        item.currentEnrollmentKey = enrollmentKey;
        batch.set(studentRef.collection('enrollments').doc(enrollmentKey), enrollment, { merge: true })
        batch.set(admissionRef.doc(admissionKey), movement, { merge: true })
        batch.set(admissionRef.doc(admissionKey).collection('enrollments').doc(enrollmentKey), enrollment, { merge: true })
        batch.set(this.ds.enrollmentFireRef().doc(enrollmentKey), movement, { merge: true })
      }
      else {
        batch.set(studentRef.collection('enrollments').doc(item.currentEnrollmentKey), enrollment, { merge: true })
        batch.update(admissionRef.doc(item.currentAdmissionKey), {
          startLevelKey: item.level.key,
          startLevelRef: this.ds.programRef().doc(item.program.key).collection('levels').doc(item.level.key).ref,
          programKey: item.program.key,
          programRef: this.ds.programRef().doc(item.program.key).ref,
          updated_at: this.ds.serverTimestamp(),
          updated_by: item.updated_by,
        })
        const enroll = {
          programKey: item.program.key,
          programRef: this.ds.programRef().doc(item.program.key).ref,
          levelKey: item.level.key,
          levelRef: this.ds.programRef().doc(item.program.key).collection('levels').doc(item.level.key).ref,
          currentLessonKey: firstLesson.key,
          currentLessonRef: this.ds.programRef().doc(item.program.key).collection('levels').doc(item.level.key).collection('lessons').doc(firstLesson.key).ref,
          updated_at: this.ds.serverTimestamp(),
          updated_by: item.updated_by,
        }
        batch.set(admissionRef.doc(item.currentAdmissionKey).collection('enrollments').doc(item.currentEnrollmentKey), enroll)
        batch.set(this.ds.enrollmentFireRef().doc(item.currentEnrollmentKey), enroll)
      }
      item.currentLessonKey = firstLesson.key;
      item.currentLessonRef = this.ds.programRef().doc(item.program.key).collection('levels').doc(item.level.key).collection('lessons').doc(firstLesson.key).ref;
      item.currentLevelKey = item.level.key;
      item.currentLevelRef = this.ds.programRef().doc(item.program.key).collection('levels').doc(item.level.key).ref;
      item.currentProgramKey = item.program.key;
      item.currentProgramRef = this.ds.programRef().doc(item.program.key).ref;
    }

    if (item.accountType.key === READING_MEMBER_OBJECT.teachers.key) {
      batch.set(this.ds.userFRef(item.key), {
        ...item,
        uid: item.key,
      }, { merge: true })
    }
    batch.set(studentRef, item, { merge: true })
    batch.commit().then(() => {
      callback(true, null);
    }).catch((error) => {
      alert(error);
      callback(false, error)
    }).finally(() => {
      this.process = false;
    })
  }

  @action
  saveSchool(item: ISchool, callback) {
    this.ds.companyRef().doc(item.key).set(item).then(() => {
      callback(true, null);
    }).catch((error) => {
      alert(error);
      callback(false, error)
    }).finally(() => {
      this.process = false;
    })
  }

  @action
  save(item: ITrainingStudent, callback) {
    this.ds.trainingStudentRef(this.filterType.key).doc(item.key).set(item).then(() => {
      callback(true, null);
    }).catch((error) => {
      alert(error);
      callback(false, error)
    }).finally(() => {
      this.process = false;
    })
  }

  @action
  addTutor(item: ITrainingTutor, callback) {
    this.ds.trainingTutorRef(this.filterType.key).doc(item.key).set(item).then(() => {
      callback(true, null);
    }).catch((error) => {
      alert(error);
      callback(false, error)
    }).finally(() => {
      this.process = false;
    })
  }

  @action
  addBatch(item: ITrainingBatch, callback) {
    this.ds.trainingBatchRef("name").doc(item.key).set(item).then(() => {
      callback(true, null);
    }).catch((error) => {
      alert(error);
      callback(false, error)
    }).finally(() => {
      this.process = false;
    })
  }

  @action
  async addAdmission(item: ITrainingAdmission, callback) {
    this.process = true;
    const batch = this.ds.batch();
    const lessonData = pushToArray(await this.ds.programRef().doc(item.programKey)
      .collection('levels').doc(item.levelKey)
      .collection('lessons', ref => ref.orderBy("pageKey").limit(1)).get().toPromise());
    if (lessonData.length === 0) {
      alert("Sorry you cannot add admission to student by incomplete lesson on resources.")
      callback(false, null)
      return;
    }
    const lesson: any = lessonData[0];
    const { activityRef } = lesson;
    if (activityRef.length === 0) {
      alert("Sorry you cannot add admission to student by incomplete activity on resources.")
      callback(false, null)
      return;
    }
    const { skillKey, activityTypeKey, key } = activityRef[0];
    const studentInfo = {
      placementTestStarting: false,
      currentSkillKey: skillKey,
      currentProgramKey: item.programKey,
      currentModuleName: activityTypeKey,
      currentModuleKey: activityTypeKey,
      currentLevelKey: item.levelKey,
      currentLessonKey: lesson.key,
      currentAdmissionKey: item.key,
      currentActivityKey: key,
      [item.programKey]: item,
    }
    const studentRef = this.ds.studentFireRef().doc(item.studentKey);
    batch.update(studentRef, { ...studentInfo })
    batch.set(studentRef.collection("student_admissions").doc(item.key), item);
    batch.set(this.ds.companyFireRef().doc(item.organizationKey).collection("student_admissions").doc(item.key), item);
    batch.set(this.ds.admissionMovementRef().doc(item.key), item);
    batch.set(this.ds.trainingBatchFireRef().doc(item.batchKey).collection('student_admissions').doc(item.key), item)
    batch.update(this.ds.trainingBatchFireRef().doc(item.batchKey), { totalStudent: firebase.firestore.FieldValue.increment(1) })
    batch.commit().then(() => {
      callback(true, null);
    }).catch((error) => {
      alert(error);
      callback(false, error)
    }).finally(() => {
      this.process = false;
    })
  }

  @action
  addNewSub(collection: string, item: any, callback) {
    this.process = true;
    const batch = this.ds.batch();
    const ref = this.ds.collectionFireRef(collection).doc(item.key)
    const schoolRef = this.ds.collectionFireRef("organizations").doc(item.schoolKey).collection(collection).doc(item.key)
    batch.set(ref, item, { merge: true })
    batch.set(schoolRef, item, { merge: true })
    batch.commit().then(() => {
      this.process = false;
      callback(true, null);
    }).catch(error => {
      this.process = false;
      callback(false, error);
    })
  }

  @action
  updateSub(collection: string, item: any, callback) {
    this.process = true;
    const batch = this.ds.batch();
    const ref = this.ds.collectionFireRef(collection).doc(item.key)
    const schoolRef = this.ds.collectionFireRef("organizations").doc(item.schoolKey).collection(collection).doc(item.key)
    batch.update(ref, item)
    batch.update(schoolRef, item)
    batch.commit().then(() => {
      this.process = false;
      callback(true, null);
    }).catch(error => {
      this.process = false;
      callback(false, error);
    })
  }

  @action
  async fetchOrganization() {
    const ref = pushToArray(await this.ds.collectionRef('organizations').get().toPromise())
    console.log('ref', ref);

    return ref;
  }
}
